import { ApiResponse, DeclinedRequest } from '../types/api';
import { lifeApi } from './base';

const postDeclined = lifeApi.injectEndpoints({
  endpoints: (builder) => ({
    postDeclined: builder.mutation<ApiResponse<void>, DeclinedRequest>({
      query: (body) => ({
        url: '/',
        method: 'POST',
        body,
        params: {
          relativeUrl: 'applications/declined',
        },
      }),
    }),
  }),
});

export const { usePostDeclinedMutation } = postDeclined;
